import { apiClient } from '@/lib/api/client'
import type { FamilyEditorSchemaDto } from './types'

export async function getCatalogFamilyEditorSchema(
  familyId: string,
  projectId: string,
  quoteVersionId?: string | null
): Promise<FamilyEditorSchemaDto> {
  const query = quoteVersionId ? `?quoteVersionId=${encodeURIComponent(quoteVersionId)}` : ''
  return await apiClient.get<FamilyEditorSchemaDto>(
    `/${encodeURIComponent(projectId)}/catalog/families/${encodeURIComponent(familyId)}${query}`
  )
}
